import orsini from "../images/orsini-busto.jpg";
import malcolmia from "../images/malcolmia.jpg";
import vipera from "../images/vipera-ursinii.jpg";

export default function Orsini() {
  return (
    <div className="container p-5">
      <h1>Antonio Orsini</h1>
      <div className="row">
        <div className="col-12 col-lg-8">
          <p className="fw-normal" style={{ textAlign: "justify" }}>
            Antonio Orsini nasce il 9 Febbraio 1788 ad Ascoli Piceno e rimane
            orfano di suo padre prima di terminare gli studi ginnasiali. In
            concomitanza di questo triste evento fu accolto dallo zio Domenico
            nella sua avviata bottega di speziale, all'angolo di Piazza del
            Popolo ad Ascoli Piceno. Il "Sor Antonio", così l'Orsini veniva
            amichevolmente chiamato dai concittadini e da quanti avevano avuto
            la fortuna di frequentarlo, aveva manifestato sin da ragazzo una
            spiccatissima attitudine verso il mondo della scienza e in
            particolare verso lo studio delle discipline naturalistiche. Imparò
            molto presto il mestiere dello zio che seguiva con molta attenzione
            sia nella preparazione dei farmaci che nel cercare di conoscere gli
            elementi da cui questi venivano prodotti. Lo interessavano
            soprattutto le erbe o "i semplici" (questo era il nome riservato
            alle piante medicinali) che il Sor Domenico acquistava dai montanari
            nei giorni di mercato quando essi scendevano ad Ascoli e venivano al
            suo negozio. Fu un illustre e appassionato botanico e naturalista,
            raccoglitore di reperti e collaboratore sia per la Flora Italica di
            Antonio Bertoloni (1775-1868), che per l'incompiuta Flora Italiana
            di Filippo Parlatore (1816-1877). Questo suo interesse lo portò ad
            andare lui stesso alla ricerca di queste piante, per poi
            raccoglierne sempre di più man mano che si imbatteva in specie e
            generi diversi. A diciotto anni conseguì brillantemente e con lode
            la "matricola" in Farmacia in prospettiva di sostituire lo zio ormai
            vecchio, che lo incoraggiò nella sua passione per le Scienze
            Naturali e lo mandò a studiare a Bologna dove divenne dottore in
            Scienze. Egli effettuò nella sua lunga vita innumerevoli escursioni
            scientifiche in Italia e all'estero alla ricerca di animali, piante,
            minerali, rocce, conchiglie e fossili; alcune specie portano oggi il
            suo nome e la raccolta che riuscì a mettere insieme costituì un
            ingente patrimonio di materiale scientifico. L'ingegno e gli
            interessi di quest'uomo erano tali, che portò contributi notevoli in
            campo geologico, botanico, zoologico, paleontologico, chimico,
            agronomico, metereologico. Poche erano le discipline nelle quali non
            aveva primeggiato ed in ognuna di esse era riuscito ad apportare
            contributi di tipo applicativo. Molte altre furono le scoperte e le
            innovazioni tecniche e scientifiche di cui fu autore. Fu un pioniere
            anche nel campo dell'agricoltura, dove sperimentò nuove coltivazioni
            e nuove forme di allevamento. In età matura l'Orsini partecipò
            attivamente anche alla vita politica; nel 1861 fu nominato senatore
            del Regno d'Italia. Fu socio di ben 35 accademie e partecipò a
            numerosi congressi scientifici.
          </p>
        </div>
        <div className="col-12 col-lg-4 text-center">
          <img
            src={orsini}
            className="img-fluid img-thumbnail"
            alt="Immagine Antonio Orsini"
          />
          <p className="text-muted">Antonio Orsini (1788-1870)</p>
        </div>
      </div>
      <div className="row py-5">
        <h1 className="text-center fw-light">Scoperte scientifiche</h1>
        <div className="col-12 col-md-4 p-4">
          <img src={malcolmia} alt="" className="img-fluid rounded-3 shadow" />
          <p className="text-muted text-center">Malcolmia orsiniana (Ten.)</p>
        </div>
        <div className="col-12 col-md-8 p-4">
          <h3>Botanica</h3>
          <p>
            Orsini ha individuato nuove specie in vari ambiti naturalistici che
            altri scienziati, in suo onore, riconoscendo il valore del suo
            lavoro, hanno chiamato dell'Orsini. Di seguito vengono riportati
            alcuni esempi:
          </p>
          <ul>
            <li>Malcomia orsiniana Tenore</li>
            <li>Carex Orsiniana</li>
            <li>Dipsacus Orsinii</li>
            <li>Fritillaria orsiniana</li>
            <li>Hesperis orsiniana</li>
            <li>Malva orsiniana</li>
            <li>Silene orsiniana</li>
          </ul>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-4 p-4">
          <img src={vipera} alt="" className="img-fluid rounded-3 shadow" />
          <p className="text-muted text-center">Vipera ursinii</p>
        </div>
        <div className="col-12 col-md-8 p-4">
          <h3>Zoologia</h3>
          <p>
            In ambito zoologico è noto alla maggior parte della popolazione per
            la vipera dell'Orsini (Vipera ursinii Bonaparte 1835) un endemismo
            dell'Italia centrale, da lui raccolta per la prima volta sul Monte
            Vettore, nel Parco Nazionale dei Monti Sibillini. Sono stati
            realizzati anche degli Itinerari naturalistici orsiniani a
            Castelluccio di Norcia. Gli sono stati dedicati anche Miniopterus
            Orsinii (pipistrello), il pesce: Ozodura Orsinii Ranzani 1839,
            l'elice Helix Orsinii, il coleottero Carbus Orsinii, Forficula
            Orsinii.
          </p>
        </div>
      </div>
    </div>
  );
}
